module.exports = __webpack_public_path__ + "img/配件管理.da2b9e16.png";